/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Tawk_DescriptionInputs */

const en_admin_settings_groups_tawk_description = /** @type {(inputs: Admin_Settings_Groups_Tawk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawk.to live chat widget`)
};

const zh_admin_settings_groups_tawk_description = /** @type {(inputs: Admin_Settings_Groups_Tawk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawk.to 客服聊天组件`)
};

/**
* | output |
* | --- |
* | "Tawk.to live chat widget" |
*
* @param {Admin_Settings_Groups_Tawk_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_tawk_description = /** @type {((inputs?: Admin_Settings_Groups_Tawk_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Tawk_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_tawk_description(inputs)
	return zh_admin_settings_groups_tawk_description(inputs)
});
export { admin_settings_groups_tawk_description as "admin.settings.groups.tawk.description" }